<template>
  <a class="button__add w-inline-block cursor-pointer">
    <div class="text-sm-bold mod--button">
      Добавить направление
    </div>
    <img
      src="/images/i-plus-dark.svg"
      loading="lazy"
      alt=""
      class="b-imgutton__add"
    >
  </a>
</template>

<script>
export default {
  name: 'LKRoadmapsFeedButtonAdd',
}
</script>
